import { useState, useEffect } from 'react';
import { BASE_SHEET_WIDTH } from '@i-ark/constants';
import { throttleToAnimationFrame } from '@utils/common';

const useSheetScale = sheetRef => {
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const node = sheetRef.current;
    if (node === null) {
      return;
    }
    const updateScale = () => {
      setScale(node.offsetWidth / BASE_SHEET_WIDTH);
    };
    updateScale();
    const observer = new ResizeObserver(throttleToAnimationFrame(updateScale));
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return scale;
};

export { useSheetScale };
//# sourceMappingURL=useSheetScale.js.map
